export namespace AppStates {
    export function appStatesFactory() {
        const app = {
            isFetching: 0,
            timestamp: new Date(),
            windowWidth: window.innerWidth,
            isWWW: false,
            bgBlur: false,
            bgBlurWithoutLogin: false,
            ltype: 1,
            bottomMargin: false,
        };
        return app;
    }

    export function mutations() {
        return {
            appStartFetching(state: any) {
                state.app.isFetching++;
            },
            appEndFetching(state: any) {
                state.app.isFetching--;
            },
            updateWindowWidth(state: any) {
                state.app.windowWidth = window.innerWidth;
            },
            updateIsWWW(state: any, is: boolean) {
                state.app.isWWW = is;
            },
            updateBottomMargin(state: any, is: boolean) {
                state.app.bottomMargin = is;
            },
            bgBlurOn(state: any) {
                state.app.bgBlur = true;
            },
            bgBlurOff(state: any) {
                state.app.bgBlur = false;
            },
            bgBlurOnWithoutLogin(state: any) {
                state.app.bgBlurWithoutLogin = true;
            },
            bgBlurOffWithoutLogin(state: any) {
                state.app.bgBlurWithoutLogin = false;
            },
            setLtype(state: any, ltype: number) {
                state.app.ltype = ltype;
            }
        };
    }
}
